module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      card: !_vm.embedded
    },
    style: (_vm.$rootForm ? {} : {
      'min-width': '40vw'
    })
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [(_vm.heading || !_vm.embedded) ? _c('div', {
    class: {
      'card-header': !_vm.embedded, clearfix: true
    }
  }, [(!_vm.embedded) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "title": _vm.i18n.fr('action.undo'),
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.undo
    }
  }, [_c('i', {
    staticClass: "ti-back-right"
  }), _vm._v("\n          " + _vm._s(_vm.i18n.fr('action.undo')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "title": _vm.i18n.fr('action.reload'),
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.reload
    }
  }, [_c('i', {
    staticClass: "ti-reload",
    class: {
      'ti-spin': _vm.loading
    }
  }), _vm._v("\n          " + _vm._s(_vm.i18n.fr('action.reload')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.heading) ? _c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.heading))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    class: {
      'card-content': !_vm.embedded
    },
    attrs: {
      "element-loading-text": _vm.i18n.fr('loading')
    }
  }, [(_vm.currentModel) ? [(_vm.categorizedColumns.length == 1) ? _vm._l((_vm.displayColumns), function(col) {
    return _c('div', {
      key: col.prop,
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v(_vm._s(col.label))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c(col.component, {
      ref: "fields",
      refInFor: true,
      tag: "component",
      attrs: {
        "name": col.prop,
        "spec": col,
        "model": _vm.currentModel,
        "$parentForm": _vm.$parentForm || _vm.self,
        "$rootForm": _vm.$rootForm || _vm.self,
        "rootModel": _vm.rootModel || _vm.currentModel,
        "readonly": _vm.readonly || col.readonly
      }
    }), _vm._v(" "), (_vm.validator.errors.has(col.prop)) ? _c('p', {
      staticClass: "text-danger"
    }, [_vm._v("\n                " + _vm._s(_vm.validator.errors.first(col.prop)) + "\n              ")]) : _vm._e()], 1)])
  }) : (_vm.categorizedColumns.length > 1) ? _c('vue-tabs', {
    ref: "tabs",
    on: {
      "tab-change": _vm.tabChanged
    }
  }, _vm._l((_vm.categorizedColumns), function(x) {
    return _c('v-tab', {
      attrs: {
        "title": x.title,
        "id": x.key
      }
    }, _vm._l((x.columns), function(col) {
      return _c('div', {
        key: col.prop,
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "col-md-2 control-label"
      }, [_vm._v(_vm._s(col.label))]), _vm._v(" "), _c('div', {
        staticClass: "col-md-10 control-content"
      }, [_c(col.component, {
        ref: "fields",
        refInFor: true,
        tag: "component",
        attrs: {
          "name": col.prop,
          "spec": col,
          "model": _vm.currentModel,
          "$parentForm": _vm.$parentForm || _vm.self,
          "$rootForm": _vm.$rootForm || _vm.self,
          "rootModel": _vm.rootModel || _vm.currentModel,
          "readonly": _vm.readonly || col.readonly
        }
      }), _vm._v(" "), (_vm.validator.errors.has(col.prop)) ? _c('p', {
        staticClass: "text-danger"
      }, [_vm._v("\n                  " + _vm._s(_vm.validator.errors.first(col.prop)) + "\n                ")]) : _vm._e()], 1)])
    }))
  })) : _vm._e()] : _c('h3', {
    staticStyle: {
      "text-align": "center"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.fr('html.not_found'))
    }
  })], 2), _vm._v(" "), (!_vm.loading && _vm.currentModel && _vm.showActions && _vm.formActions) ? _c('div', {
    staticClass: "text-right",
    class: {
      'card-footer': !_vm.embedded
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.processing),
      expression: "processing"
    }],
    staticClass: "ti-reload ti-spin",
    staticStyle: {
      "font-size": "large"
    }
  }), _vm._v(" "), _vm._l((_vm.formActions), function(act, i) {
    return [_c('button', {
      staticClass: "btn btn-fill btn-wd",
      class: act.class,
      attrs: {
        "type": "button",
        "disabled": _vm.processing
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.handleAction(act, String(i))
        }
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.processing === String(i)),
        expression: "processing === String(i)"
      }],
      staticClass: "ti-reload ti-spin"
    }), _vm._v("\n          " + _vm._s(act.label) + "\n        ")]), _vm._v(" \n      ")]
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c8dfaa1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/SchemaBaseForm.vue
// module id = 533
// module chunks = 55